import { __assign, __spreadArrays } from "tslib";
import AnalyticsVersions from "./AnalyticsVersions";
import { resolveAnalyticsGlobalByVersion } from "./Utils";
export var GoogleAnalyticsGtmClientCommands;
(function (GoogleAnalyticsGtmClientCommands) {
    GoogleAnalyticsGtmClientCommands["Config"] = "config";
    GoogleAnalyticsGtmClientCommands["Get"] = "get";
    GoogleAnalyticsGtmClientCommands["Set"] = "set";
    GoogleAnalyticsGtmClientCommands["Event"] = "event";
    GoogleAnalyticsGtmClientCommands["Consent"] = "consent";
})(GoogleAnalyticsGtmClientCommands || (GoogleAnalyticsGtmClientCommands = {}));
/**
 * Client for Google Analytics - Google Tag Manager client (dataLayer)
 */
var GoogleAnalyticsGtmClient = /** @class */ (function () {
    function GoogleAnalyticsGtmClient(config) {
        var _this = this;
        /**
         * Send a event to gtag
         */
        this.event = function (eventName, data) {
            var _a;
            _this.gtm(__assign((_a = {}, _a[GoogleAnalyticsGtmClientCommands.Event] = eventName, _a), data));
            // this.gtm(Commands.Event, data);
        };
        /**
         * Set the custom map
         * @var customMap Object containing the custom map properties.
         */
        this.config = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.gtm.apply(_this, __spreadArrays([GoogleAnalyticsGtmClientCommands.Config], args));
        };
        this.set = function (data) {
            _this.gtm(data);
        };
        this.gtm = resolveAnalyticsGlobalByVersion(AnalyticsVersions.GoogleTagManager);
    }
    return GoogleAnalyticsGtmClient;
}());
export default GoogleAnalyticsGtmClient;
//# sourceMappingURL=GoogleAnalyticsGtmClient.js.map